<template lang="pug">
  b-modal(
    v-model="show",
  )
    template(v-slot:modal-header).modal-header
      h5.modal-title {{dialog.title}}
    b-container(fluid, v-html="dialog.context")
    div(slot="modal-footer", class="w-100")
      b-btn(
        class="float-right ml-2"
        v-for="(button, index) in dialog.buttons"
        :key="index"
        :size="buttonSize(button)"
        :variant="button.color"
        @click="button.action(close)"
      ) {{button.text}}
      b-btn(
        class="float-right ml-2"
        :size="buttonSize(buttonInfo)"
        variant="secondary"
        @click="onClickCancel"
      ) {{$t('cancel')}}
</template>

<script>
import _ from "lodash"

const defaultValues = {
  size: "lg",
  title: "",
  context: "",
  buttons: [],
  headerBgVariant: "light",
  headerTextVariant: "dark",
  bodyBgVariant: "light",
  bodyTextVariant: "dark",
  footerBgVariant: "light",
  footerTextVariant: "dark",
}

export default {
  name: "action-dialog",
  computed: {
    isMobile() {
      if (this.AppState.isApplication) return true
      if (!this.$mq) return false
      if (this.$mq.resize && this.$mq.isMobile()) return true
      return false
    },
  },
  methods: {
    buttonSize(button) {
      if (this.isMobile) {
        return "md"
      } else {
        return button.size || "sm"
      }
    },
    close() {
      this.show = false
    },
    onClickCancel() {
      this.show = false
    },
    onClickDownload() {
      window.open(`${process.env.VUE_APP_API_ADDRESS}/download/ManualLauncher.exe?cache=210621_02`, "_blank")
    },
  },
  created() {
    this.dialog = defaultValues
    this.AppState.$on("show-action-dialog", data => {
      this.dialog = _.assign(this.dialog, data)
      this.buttonInfo = data.buttons[0] || {}
      this.isDownload = data.download || false
      this.show = true
    })
  },
  data() {
    return {
      show: false,
      dialog: {},
      isDownload: false,
      buttonInfo: {},
    }
  },
}
</script>

<!--<style lang="scss" scoped src="./dialogs.scss"></style>-->
<style lang="scss" scoped>
::v-deep .modal-header {
  background-color: #fafafa !important;
  padding: 1rem 1rem 0.75rem 1rem;
  h5 {
    font-size: 1.1rem;
    font-weight: 550;
  }
}

.container-fluid {
  padding-left: 0;
  font-size: 0.9rem;
  color: #545b64;
}

::v-deep .modal-footer {
  border: none;
}

.btn-primary {
  color: black;
  &:hover {
    color: black;
  }
  &:active {
    color: black;
  }
}

.btn-secondary {
  color: #6f6f6f !important;
  background-color: #ffffff;
  font-weight: 400;
}

.btn-secondary:hover {
  color: black !important;
  background-color: #f7f7f7 !important;
  border: 1px solid #9c9c9c !important;
  font-weight: 400;
}

.btn-secondary:active {
  color: black !important;
  background-color: #cbcbcb !important;
  border: 1px solid #9c9c9c !important;
  font-weight: 400;
}
</style>